import { useEffect } from "react";
import type { Command } from "../components/common/CommandPalette";

/**
 * Register a list of context-aware commands with the global command palette
 * for the lifetime of the calling component. The palette listens to the
 * `agntspace:register-commands` custom event and merges the supplied list
 * with its built-in nav + action set.
 *
 * Pages should call this with the commands relevant to the currently
 * selected entity (e.g. "Pause this goal", "Reassign this task").
 */
export function useRegisterCommands(commands: Command[], deps: ReadonlyArray<unknown> = []) {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		window.dispatchEvent(
			new CustomEvent("agntspace:register-commands", { detail: commands }),
		);
		return () => {
			window.dispatchEvent(
				new CustomEvent("agntspace:register-commands", { detail: [] }),
			);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
}
